<app-card-wrapper
  *ngIf="_card"
  [backgroundImage]="_card.backgroundImage"
  [backgroundColor]="_card.backgroundColor"
  [backgroundPosition]="_card.backgroundPosition"
  [backgroundSize]="_card.backgroundSize"
  [overlay]="_card.backgroundOverlay === 'auto'"
>
  <app-card-roleplay
    *ngIf="_card.isRolePlay"
    [videos]="['../../../../../assets/img/conference/roleplay1.mp4', '../../../../../assets/img/conference/roleplay2.mp4']"
    (onPlayFinished)="onPlayFinishedHandler($event)"
  ></app-card-roleplay>

  <app-card-video
    *ngIf="_card.url1 && (_card.type === 'video' || (isVideo && !_isResults))"
    [card]="_card"
    (onPlayFinished)="onPlayFinishedHandler($event)"
  ></app-card-video>

  <app-card-title
    *ngIf="!isWaitingRolePlay && _card.isTitle"
    [title]="_card.title"
    [color]="_card.titleColor"
  ></app-card-title>

  <app-card-text
    *ngIf="!isWaitingRolePlay && _card.isText"
    [text]="_card.text"
    [color]="_card.color"
  ></app-card-text>

  <app-card-questionnaire
    *ngIf="!isWaitingRolePlay && ['quiz', 'poll'].includes(_card.type)"
    [card]="_card"
    [isResults]="_isResults"
    (onSubmit)="onSubmitHandler($event)"
  ></app-card-questionnaire>

  <app-card-reorder
    *ngIf="!isWaitingRolePlay && _card.type == 'dragAndDrop'"
    [card]="_card"
    [isResults]="_isResults"
    (onSubmit)="onSubmitHandler($event)"
  ></app-card-reorder>

  <app-card-drag-to-group
    *ngIf="!isWaitingRolePlay && _card.type == 'dragToGroup'"
    [card]="_card"
    [isResults]="_isResults"
    (onSubmit)="onSubmitHandler($event)"
  ></app-card-drag-to-group>

  <app-card-drag-and-match
    *ngIf="!isWaitingRolePlay && _card.type == 'dragAndMatch'"
    [card]="_card"
    [isResults]="_isResults"
    (onSubmit)="onSubmitHandler($event)"
  ></app-card-drag-and-match>

  <app-card-rating
    *ngIf="!isWaitingRolePlay && _card.type == 'rating'"
    [card]="_card"
    [isResults]="_isResults"
    (onSubmit)="onSubmitHandler($event)"
  ></app-card-rating>

  <app-card-audio
    *ngIf="!isWaitingRolePlay && _card.type === 'audio'"
    [card]="_card"
    [title]="_card.title"
    [audio]="_card.url1"
  ></app-card-audio>

  <app-card-form
    *ngIf="!isWaitingRolePlay && _card.type === 'form'"
    [card]="_card"
    [isResults]="_isResults"
    [isWordCloudReady]="isWordCloudReady"
    (onSubmit)="onSubmitHandler($event)"
  ></app-card-form>

</app-card-wrapper>
